/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PersonalDocumentStatus = {
  type: 'Enum',
} as const;
